import { Mark, mergeAttributes } from "@tiptap/core";
import { getTextSizeClassName } from "./TextSizeUtils";
export const SizedSpan = Mark.create({
    name: "sizedSpan",
    priority: 1100,
    addOptions() {
        return {
            defaultTextSize: "body14",
            HTMLAttributes: {},
        };
    },
    addAttributes() {
        return {
            class: {
                default: getTextSizeClassName(this.options.defaultTextSize),
                parseHTML: (element) => element.getAttribute("class"),
            },
        };
    },
    renderHTML({ HTMLAttributes }) {
        return [
            "span",
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
            0,
        ];
    },
    parseHTML() {
        return [{ tag: "span" }];
    },
    addCommands() {
        return {
            setTextSize: (textSize) => ({ chain, editor }) => {
                const textSizeClassName = getTextSizeClassName(textSize);
                return (chain()
                    .command(({ tr }) => {
                    const from = editor.view.state.selection.$from;
                    const to = editor.view.state.selection.$to;
                    // Loop through all selected nodes.
                    // If a paragraph is completely selected, then add the text size class to the paragraph.
                    // This way the line height is ajusted, and the text size sticks even if one doesn't type anything.
                    editor.state.doc.nodesBetween(from.pos, to.pos, (node, pos) => {
                        if (node.type.name === "paragraph" &&
                            pos >= from.pos - 1 &&
                            pos + node.content.size <= to.pos) {
                            tr.setNodeAttribute(pos, "class", textSizeClassName);
                        }
                    });
                    return true;
                })
                    // Create a span with specified text size around selected text.
                    // This is needed to support changing the text size of a portion of a paragraph.
                    .setMark(this.name, {
                    class: textSizeClassName,
                })
                    .run());
            },
        };
    },
});
//# sourceMappingURL=SizedSpan.js.map